let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8juF1")).then(() => parcelRequire('haP7h'));